<template>
  <svg
    :width="width"
    :height="height"
    :viewBox="viewBox"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66667 5.05679L7 0.5225L11.3333 5.01286M7 0.5V12.2857M0.5 15.5H13.5"
      :stroke="fill"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    viewBox: { type: String, default: "0 0 14 16" },
    width: { type: [Number, String], default: 14 },
    height: { type: [Number, String], default: 16 },
    iconName: { type: String, default: "icon" },
    fill: { type: String, default: "#0038FF" },
  },
};
</script>
